import URL from 'url';

/**
 * Model
 */
class Model {
  private static _language: string = 'zh-CN';

  public static get language(): string {
    return Model._language;
  }

  public static set language(value: string) {
    this._language = value || '';
  }

  public static init() {
    Model._language = this.getLanguage();
  }

  private static getLanguage() {
    const effectLanguage = ['zh-CN', 'en'];
    const query = URL.parse(window.location.href, true).query;
    const urlLanguage = query.language as string;
    let result = urlLanguage || 'zh-CN';
    if (!effectLanguage.includes(result)) {
      if (result.startsWith('en')) {
        result = 'en';
      } else {
        result = 'zh-CN';
      }
    }
    return result;
  }
}
export default Model;
